/** MUI */
import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    styled,
} from "@mui/material";

/** Component styles */
const MenuProps = {
    PaperProps: {
        style: {
            borderRadius: 6,
            boxShadow: '4px 4px 10px 5px rgba(33, 0, 63, 0.1)',
            maxHeight: 310,
            width: 200,
        },
    },
};

const MenuProps2 = {
    PaperProps: {
        style: {
            borderRadius: 6,
            boxShadow: '4px 4px 10px 5px rgba(33, 0, 63, 0.1)',
            maxHeight: 500,
        },
    },
};

const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
    color: theme.palette.V080,     // Color por defecto
    fontWeight: 600,               // Peso de la fuente por defecto
    "&.Mui-focused": {
        color: theme.palette.V090, // Color cuando el label está enfocado
    },
    "&.Mui-disabled": {
        color: theme.palette.V050, // Color cuando el label está desactivado
    },
}));

// Estilo personalizado para el Select
const StyledSelect = styled(Select)(({ theme }) => ({
    // Estilos para el contenedor principal
    backgroundColor: "white",
    "& .Mui-disabled": {
        WebkitTextFillColor: theme.palette.V050,
    },
    "&.Mui-error": {
        "& .MuiSvgIcon-root": {
            fill: theme.palette.error.main,
        },
    },

    // Aplica el color del borde por defecto
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V050,
        borderRadius: 6,
    },

    // Aplica el color del borde en hover
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V090,
    },

    // Aplica el color del borde en focus
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V100,
    },

    // Aplica el color del borde en desactivado
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.V010,
    },

    // Aplica el color del ícono de flecha
    "& .MuiSvgIcon-root": {
        fill: theme.palette.V090,
        "&.Mui-disabled": {
            fill: theme.palette.V050,
        },
    },
}));

export default function BaseSelect2(props) {
    const {
        children,
        customStyle,
        disabled,
        error,
        hasTooltip,
        id,
        idName,
        issearch = false,
        label,
        language,
        multiple,
        name, required,
        onChange,
        renderValue,
        shrink,
        sx,
        type,
        value,
        valueName,
        values,
        ...rest
    } = props;

    return (
        <FormControl fullWidth error={error} disabled={disabled} required={required} sx={{ height: issearch ? 42 : 48, width: customStyle ? 200 : "100%" }}>
            <StyledInputLabel id={"customized-base-select-label" + id} shrink={shrink}>
                {label}
            </StyledInputLabel>
            <StyledSelect
                {...rest}
                labelId={"customized-base-select-label" + id}
                id={"customized-base-select" + id}
                value={value}
                onChange={onChange}
                name={name}
                MenuProps={customStyle ? MenuProps2 : MenuProps}
                label={label}
                sx={{ height: issearch ? 42 : 48, ...sx }}  // Establecer la altura del Select
                variant="outlined" // Asegúrate de usar la variante "outlined"
                multiple={multiple}
                renderValue={renderValue}
            >
                {children ? children : 
                    values.map((item) => (
                        <MenuItem key={item[valueName] + "_" + item[idName]} value={item[idName]} sx={{display: item[idName] === "hidden" ? "none" : "block"}}>
                            {item[valueName]}
                        </MenuItem>
                    ))
                }
            </StyledSelect>
        </FormControl>
    );
}
